import {useEffect} from "react";

interface ProcessingGuardsPrompts {
    leavePrompt: string;
    backPrompt: string;
}

/**
 * Warns the user before leaving the page or navigating back while active.
 * Pass the prompts to display for the unload and back-navigation attempts.
 */
export const usePreventNavigation = (
    active: boolean,
    {leavePrompt, backPrompt}: ProcessingGuardsPrompts
): void => {
    useEffect(() => {
        if (!active) {
            return;
        }

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = leavePrompt;
        };

        const handlePopState = () => {
            if (!window.confirm(backPrompt)) {
                window.history.forward();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("popstate", handlePopState);
        };
    }, [active, leavePrompt, backPrompt]);
};
